import { useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { UseCaseHomepage } from "@similarweb/ui-components";

import { KeywordsWebsitesRecentsWidget } from "app/pages/digital-suite/home-page/components/RecentsWidget/KeywordsWebsitesRecentsWidget";
import { translate } from "app/filters/i18nFilter";
import { ScrollContainer } from "app/components/layout/ScrollContainer";
import { AutocompleteDigitalMarketing } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketing";
import { ROUTES as publisherAnalysisRoutes } from "single-spa/react-app/config/solutions25/adIntelligence/publisherAnalysis/publisherAnalysisConstants";
import { SecondaryHomePageHeaderImageUrl } from "app/UtilitiesAndConstants/Constants/Images";

const AutocompleteWrapper = styled.div`
    width: 100%;

    & div.AutoCompleteContainer {
        z-index: 5;
    }
`;

const WEBSITE_NAVIGATION_STATE = publisherAnalysisRoutes.overview;
const FILTER_RECENTS_BY = "adintelligence-publisheranalysis.root.frame";

export const suggestedEntities = [
    { name: "espn.com" },
    { name: "cnbc.com" },
    { name: "nationalgeographic.com" },
    { name: "vogue.com" },
    { name: "travelandleisure.com" },
];

const suggestions = suggestedEntities.map((entity) => entity.name);

const PublisherAnalysisHomePage = () => {
    const { state } = useCurrentStateAndParams();
    const [autocompleteOpen, setAutocompleteOpen] = useState(false);

    return (
        <ScrollContainer>
            <UseCaseHomepage
                title={translate(state.pageTitle as string)}
                titlePosition="left-aligned"
                subtitle={translate("ad.intelligence.publisher.analysis.homepage.subtitle")}
                headerImageUrl={SecondaryHomePageHeaderImageUrl}
                searchComponents={
                    <AutocompleteWrapper>
                        <AutocompleteDigitalMarketing
                            includeKeywordsData={false}
                            maxCompareItemsToDisplay={1}
                            onAutocompleteOpen={() => setAutocompleteOpen(true)}
                            onAutocompleteClose={() => setAutocompleteOpen(false)}
                            websiteState={WEBSITE_NAVIGATION_STATE}
                            suggestedEntities={suggestions}
                        />
                    </AutocompleteWrapper>
                }
                listItems={[
                    <KeywordsWebsitesRecentsWidget
                        key="recents"
                        withoutKeywords
                        suggestedEntities={suggestions}
                        filterRecentsBy={FILTER_RECENTS_BY}
                        suggestionsTargetState={WEBSITE_NAVIGATION_STATE}
                    />,
                ]}
            />
        </ScrollContainer>
    );
};

export default PublisherAnalysisHomePage;
